import { render, staticRenderFns } from "./InputValidation.vue?vue&type=template&id=a0735dce"
import script from "./InputValidation.vue?vue&type=script&lang=js"
export * from "./InputValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports